/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { CheckCircleOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Menu,
  message,
  Modal,
  Row,
  Spin,
  Tabs,
  TreeSelect,
  Typography,
  Upload,
} from 'antd';
import API from 'utils/api';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getDirectorioDeAreas } from 'api/catalogos/CatalogoDeAreas';
import { getCategoriasDePuestos } from 'api/catalogos/categoriaDePuestos';
import { getEstadosGlobales } from 'api/catalogos/index';
import { getMotivosDeReclutamiento } from 'api/catalogos/motivosReclutamiento';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuesto, getPuestos } from 'api/catalogos/puestos';
import { getSindicatos } from 'api/catalogos/sindicatos';
import { getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleadoOptimized } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated, getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPrioridades } from 'api/Prioridad';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import {
  deleteCompetenciaRequerida,
  getCompetenciasRequeridas,
  patchCompetenciaRequerida,
  postCompetenciaRequerida,
} from 'api/reclutamiento/competenciasRequeridasSolicitud';
import {
  deleteFuncionPrincipal, getFuncionesPrincipales, patchFuncionPrincipal, postFuncionPrincipal,
} from 'api/reclutamiento/funcionesPrincipales';
import {
  autorizarSolicitudDeContratacion,
  deleteSolicitudDeContratacion,
  getComprobantesDeEstudio,
  getSolicitudDeContratacion,
  getSolicitudDeContratacionvistaOptimized,
  getSolicitudesDeContratacion,
  getSolicitudesDeContratacionFiltro,
  patchSolicitudDeContratacion,
  postSolicitudDeContratacion,
} from 'api/reclutamiento/SolicitudesDeContratacion';
import { checkToken } from 'api/utils';
import CustomSearch from 'components/customSearch';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Dragger from 'components/Dragger';

export const listadoDeVacantes = {
  permissionModel: 'solicituddecontratacion',
};
const baseURIImportar = 'nominas/solicitud-de-contratacion-importar-excel/';
const baseURL = '';
// Estados de plaza válidos para elegir una plaza al capturar una vacante
const ESTADOS_PLAZA_VACANTE = ['AUTORIZADA', 'DISPONIBLE', 'DESASIGNADA'];

const ListadoDeVacantes = ({ permission }) => {
  const [form] = Form.useForm();
  const [formFiltros] = Form.useForm();
  const [formEmpleados] = Form.useForm();
  const [solicitudes, setSolicitudes] = useState();
  const [cantidadSolicitudes, setCantidadSolicitudes] = useState(0);
  const [estados, setEstados] = useState([]);
  const [directorioDeAreas, setDirectorioDeAreas] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);

  const [empleadoId, setEmpleadoId] = useState();
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [sindicatos, setSindicatos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tipoNominaEmpleadoID, setTipoNominaEmpleadoID] = useState([]);
  const [estadosDelEmpleado, setEstadosDelEmpleado] = useState([]);
  const [periodosDetallesFiltered, setPeriodosDetallesFiltered] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [nominaPlaza, setNominaPlaza] = useState();
  const [comprobantesDeEstudio, setComprobantesDeEstudio] = useState([]);
  const [nivelEstudio, setNivelEstudio] = useState([]);
  const [filteredSolicitudes, setFilteredSolicitudes] = useState([]);
  const [open, setVisible] = useState(false);
  const [openModalEmpleado, setOpenModalEmpleados] = useState(false); const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('solicitante');
  const [IsDisabledCompetenciasTab, setIsDisabledCompetenciasTab] = useState(true);
  const [IsDisabledFuncionesTab, setIsDisabledFuncionesTab] = useState(true);
  const [IsDisabledSolicitanteTab, setIsDisabledSolicitanteTab] = useState(false);
  const [IsDisabledPlazaTab, setIsDisabledPlazaTab] = useState(false);
  const [ultimaSolicitudGuardada, setUltimaSolicitudGuardada] = useState(null);
  const [originalSolicitudes, setOriginalSolicitudes] = useState([]);
  const [competencias, setCompetencias] = useState([]);
  const [openModalComp, setOpenModalComp] = useState(false);
  const [selectedCompIndex, setSelectedCompIndex] = useState(null);
  const [formCompetencia] = Form.useForm();
  const [formCarga] = Form.useForm();
  const [visibleModalCarga, setVisibleModalCarga] = useState(false);
  const [selectedRowKeysComp, setSelectedRowKeysComp] = useState([]);
  const [plazasFiltradas, setPlazasFiltradas] = useState([]);
  const [funcionesPrincipales, setFuncionesPrincipales] = useState([]);
  const [openModalFuncion, setOpenModalFuncion] = useState(false);
  const [selectedFuncionIndex, setSelectedFuncionIndex] = useState(null);
  const [formFuncion] = Form.useForm();
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [paginacionSolicitudes, setPaginacionSolicitudes] = useState(1);
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  const [motivosDeReclutamiento, setMotivosDeReclutamiento] = useState([]);
  // const [tiposDeNominaEmpleados, setTiposDeNominaEmpleados] = useState(null);

  // variables para el control de la info del solicitante:
  const [empleadoTexto, setEmpleadoTexto] = useState('');
  const [puestoTexto, setPuestoTexto] = useState('');
  const [areaTexto, setAreaTexto] = useState('');
  const [plazaTexto, setPlazaTexto] = useState('');
  const [categoriaTexto, setCategoriaTexto] = useState('');
  const [prioridades, setPrioridades] = useState([]);

  // Variables para el control de la info de la plaza
  const [plazaAreaTexto, setPlazaAreaTexto] = useState('');
  const [plazaPuestoTexto, setPlazaPuestoTexto] = useState('');
  const [plazaCategoriaTexto, setPlazaCategoriaTexto] = useState('');

  const TAB_DISPONIBLES = 'disponibles';
  const TAB_CONTRATADAS = 'contratadas';
  const [activeGridTab, setActiveGridTab] = useState(TAB_DISPONIBLES);
  const [tabFilteredSolicitudes, setTabFilteredSolicitudes] = useState([]);

  const nombreEntidad = useSelector(({ auth }) => auth.entidad?.nombre || '');

  let baseURI = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';
  const { Text } = Typography;
  // Funciones para la busqueda de empleados

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURI = `${baseURI}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURI = `${baseURI}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURI = `${baseURI}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURI = `${baseURI}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURI = `${baseURI}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURI);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURI);
    setData(formatReceivedClone(_empleados));
    return setLoading(false);
  };

  // Funcion para manejar el cambio en el campo de búsqueda de empleados
  const onChangeEmpleado = async (val) => {
    if (val) {
      setEmpleadoId(val);

      try {
      // Obtener el empleado por su ID si es necesario (fetch puntual)
        const _empleado = await getEmpleado(val); // o usar uno local si ya lo tienes

        // Obtener dato operacional puntual
        const [_datosOperacionales] = await getDatoOperacionalesDeEmpleados({ empleado: val });

        // Buscar la plaza relacionada
        const _plaza = plazas.find((e) => e.id === _datosOperacionales?.plaza);

        //  Traer el puesto completo por ID
        let _puestoCompleto = null;
        if (_plaza?.puesto_id) {
          _puestoCompleto = await getPuesto(_plaza.puesto_id);
        }

        const nombreCompleto = _empleado?.numero_y_nombre_completo
          ? _empleado.numero_y_nombre_completo
          : `${_empleado?.numero_de_empleado} - ${_empleado?.nombre} ${_empleado?.apellido_paterno} ${_empleado?.apellido_materno}`;
        const areaStr = _plaza?.directorio_area_clave_y_nombre || '';

        // Llenar campos del formulario
        form.setFieldsValue({
          empleado: _empleado?.id,
          puesto: _plaza?.puesto_id,
          area_adscripcion: _plaza?.directorio_area_id,
          categoria: _plaza?.categoria_de_puesto_id,
          plaza: _plaza?.id,
        });

        // Mostrar textos
        setEmpleadoTexto(nombreCompleto);
        setPuestoTexto(_puestoCompleto ? `${_puestoCompleto.clave} - ${_puestoCompleto.descripcion}` : (_plaza?.puesto || ''));
        setAreaTexto(areaStr);
        setCategoriaTexto(_plaza?.categoria_de_empleado || '');
        setPlazaTexto(_plaza?.clave_y_descripcion || '');

        setTipoNominaEmpleadoID(_datosOperacionales?.tipo_de_nomina_empleado);
        setPeriodosDetallesFiltered([]);
        setNominas([]);
      } catch (error) {
        onError(error);
      }
    } else {
      form.resetFields();
    }

    formEmpleados.resetFields(['periodo', 'nomina', 'periodo_fiscal']);
  };

  const columnsBusquedaEmpleados = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (empObject) => {
        const adminPlazaEmp = adminPlazas.result?.find((admP) => admP?.empleado === empObject?.id);
        const plazaEmp = plazas?.resuls?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
        const puestoEmp = puestos?.results?.find((p) => p?.id === plazaEmp?.puesto);
        return `${puestoEmp?.descripcion || ''}`;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  // FIN de funciones para la buqueda de empleados

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // Estado exclusivo para selección de filas en la tabla de Funciones Principales
  const [selectedRowKeysFuncion, setSelectedRowKeysFuncion] = useState([]);
  // NORMALIZACION DE LOS DATOS

  const getPathById = (nodes, id) => {
    let result = '';

    const search = (items) => items.some((node) => {
      if (node.value === id) {
        result = node.path;
        return true;
      }
      if (node.children?.length) {
        return search(node.children);
      }
      return false;
    });

    search(nodes);
    return result;
  };

  // Construye los paths concatenados
  const buildAreaPaths = (areasData) => {
    const areaMap = new Map(areasData.map((a) => [a.id, a]));

    return areasData.map((area) => {
      const path = [];
      let current = area;

      while (current) {
        path.unshift(current.nombre.trim());
        current = areaMap.get(current.directorio_area_padre);
      }

      return {
        ...area,
        path: path.join(' / '),
      };
    });
  };

  // Convierte a estructura de árbol con nodos padre deshabilitados
  const normalizeTree = (dataTree) => {
    const sortedData = buildAreaPaths(dataTree).sort((a, b) => a.clave.localeCompare(b.clave));
    const map = new Map();
    const tree = [];

    sortedData.forEach((item) => {
      const node = {
        title: `${item.clave} - ${item.nombre.trim()}`,
        value: item.id,
        key: item.id,
        children: [],
        path: item.path,
      };
      map.set(item.id, node);
    });

    sortedData.forEach((item) => {
      const parentId = item.directorio_area_padre;
      if (parentId && map.has(parentId)) {
        const parent = map.get(parentId);
        parent.children.push(map.get(item.id));
        parent.disabled = true;
      } else {
        tree.push(map.get(item.id));
      }
    });

    return tree;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const _solicitudesRaw = await getSolicitudDeContratacionvistaOptimized();
      const _solicitudes = Array.isArray(_solicitudesRaw) ? _solicitudesRaw : (_solicitudesRaw?.results || []);
      setCantidadSolicitudes(_solicitudes.length);
      setSolicitudes(_solicitudes);
      setOriginalSolicitudes(_solicitudes);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const catalogosCargadosRef = useRef(false);

  const fetchConceptos = async () => {
    if (catalogosCargadosRef.current) return;

    try {
      const [
        _estados,
        _plazas,
        _comprobantesDeEstudios,
        _nivelesDeEstudio,
        _prioridades,
        _puestos,
        _tiposNomina,
        _areas,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPlazasvistaOptimized(),
        getComprobantesDeEstudio(),
        getNivelesDeEstudios(),
        getPrioridades(),
        getPuestos(),
        getTiposDeNominasEmpleados(),
        getDirectorioDeAreas(),
      ]);

      // Asignar los valores obtenidos
      setPrioridades(_prioridades);
      setEstados(_estados);
      setPlazas(_plazas);
      setDirectorioDeAreas(Array.isArray(_areas) ? _areas : (_areas?.results || []));
      setPuestos(_puestos);
      setTiposDeNominaEmpleado(_tiposNomina?.results || _tiposNomina || []);
      const _comprobantesDeEstudiosLimpios = Object.values(_comprobantesDeEstudios).filter(
        (item) => typeof item === 'object' && item.id,
      );
      setComprobantesDeEstudio(_comprobantesDeEstudiosLimpios);

      const _nivelesDeEstudioLimpios = Object.values(_nivelesDeEstudio).filter(
        (item) => typeof item === 'object' && item.id,
      );
      setNivelEstudio(_nivelesDeEstudioLimpios);

      catalogosCargadosRef.current = true;
    } catch (err) {
      onError(err);
    }
  };
  const withId = (arr = []) => arr.map((r) => ({ ...r, id: r.vacante_id }));

  // donde ordenas:
  useEffect(() => {
    if (Array.isArray(solicitudes) && solicitudes.length > 0) {
      const ordenadas = [...solicitudes].sort((a, b) => a.vacante_id - b.vacante_id);
      setFilteredSolicitudes(withId(ordenadas)); // <-- importante
    } else {
      setFilteredSolicitudes([]);
    }
  }, [solicitudes]);
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        const [
          _solicitudes,
          _funcionesPrincipales,
          _motivosDeReclutamiento,
        ] = await Promise.all([
          getSolicitudDeContratacionvistaOptimized(),
          getFuncionesPrincipales(),
          getMotivosDeReclutamiento(),

        ]);

        const solicitudesArray = Array.isArray(_solicitudes) ? _solicitudes : (_solicitudes?.results || []);
        if (mounted) {
          setCantidadSolicitudes(solicitudesArray.length);
          setSolicitudes(solicitudesArray);
          setOriginalSolicitudes(solicitudesArray);
          setFuncionesPrincipales(Array.isArray(_funcionesPrincipales) ? _funcionesPrincipales : (_funcionesPrincipales?.results || []));
          setMotivosDeReclutamiento(_motivosDeReclutamiento);
        }
      } catch (error) {
        onError(error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onBuscar = () => {
    const filtros = formFiltros.getFieldsValue();
    let filtrados = [...originalSolicitudes];

    // === NOMBRE O NÚMERO DE EMPLEADO (campo combinado tipo: "16 - CARLOS MONTES ORTIZ") ===
    if (filtros.numeroEmpleado) {
      filtrados = filtrados.filter((e) => String(e.solicitante || '').toLowerCase().includes(filtros.numeroEmpleado.toLowerCase()));
    }

    if (filtros.nombreCompleto) {
      filtrados = filtrados.filter((e) => String(e.solicitante || '').toLowerCase().includes(filtros.nombreCompleto.toLowerCase()));
    }

    // === FOLIO DE VACANTE ===
    if (filtros.folio) {
      filtrados = filtrados.filter((e) => String(e.vacante__folio || '').toLowerCase().includes(filtros.folio.toLowerCase()));
    }

    // === FECHA DE SOLICITUD ===
    if (filtros.fecha_de_solicitud) {
      filtrados = filtrados.filter((e) => moment(e.vacante_fecha_de_solicitud).isSame(filtros.fecha_de_solicitud, 'day'));
    }

    // === FILTROS DE DATOS DEL SOLICITANTE ===
    if (filtros.plaza) {
      filtrados = filtrados.filter(
        (e) => String(e.solicitante_plaza_id) === String(filtros.plaza),
      );
    }

    if (filtros.directorio_area) {
      filtrados = filtrados.filter(
        (e) => String(e.solicitante_directorio_de_area_id) === String(filtros.directorio_area),
      );
    }

    if (filtros.puesto) {
      filtrados = filtrados.filter(
        (e) => String(e.solicitante_puesto_id) === String(filtros.puesto),
      );
    }

    // === TIPO DE EMPLEADO (si está presente en tu respuesta) ===
    if (filtros.tipo_nomina_empleado) {
      filtrados = filtrados.filter(
        (e) => String(e.tipo_de_empleado_id) === String(filtros.tipo_nomina_empleado),
      );
    }

    // === ESTATUS (del campo vacante_estado_global_id) ===
    if (filtros.estatus) {
      filtrados = filtrados.filter(
        (e) => String(e.vacante_estado_global_id) === String(filtros.estatus),
      );
    }

    setFilteredSolicitudes(filtrados);
  };

  // REGLAS
  const requiredRule = {
    required: true,
    message: 'Este campo es obligatorio',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
  };

  // Función para manejar el clic en una fila de la tabla
  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  // Función para manejar el tipo de selección de filas
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  // Configuración de columnas de la tabla
  // fecha de solicitud, folio, nombre del solitante, area de adscripcion, coordinacion, puesto, plaza, coordinacion, puesto, categoria, no de oficio, motivo, estatus
  const columns = [
    {
      titleText: 'Vacante Solicitada',
      // align: 'center',
      children: [
        // {
        //   title: 'Id Vacante',
        //   dataIndex: 'vacante_id',
        //   key: 'vacante_id',
        //   width: 120,
        // },
        {
          title: 'Folio',
          dataIndex: 'vacante__folio',
          key: 'folio',
          width: 120,
        },
        {
          title: 'Fecha de Solicitud',
          dataIndex: 'vacante_fecha_de_solicitud',
          key: 'fecha_de_solicitud',
          width: 150,
        },
        {
          title: 'Área Vacante',
          dataIndex: 'vacante_directorio_de_area_clave_y_nombre',
          key: 'vacante_area',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Puesto Vacante',
          dataIndex: 'vacante_puesto_clave_y_descripcion',
          key: 'vacante_puesto',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Plaza Vacante',
          dataIndex: 'vacante_plaza_clave_y_descripcion',
          key: 'vacante_plaza',
          width: 250,
          render: (val) => val ?? '—',
        },
        // {
        //   title: 'No. de Oficio',
        //   dataIndex: 'vacante_no_de_oficio',
        //   key: 'no_de_oficio',
        //   width: 200,
        // },
        {
          title: 'Motivo',
          dataIndex: 'vacante_motivo_de_reclutamiento_nombre',
          key: 'motivo',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Prioridad',
          dataIndex: 'vacante_prioridad_de_la_adquisicion_descripcion',
          key: 'vacante_prioridad_de_la_adquisicion_descripcion',
          width: 250,
        },

        {
          title: 'Fecha para Ocupar la Vacante',
          dataIndex: 'vacante_fecha_para_ocupar_la_vacante',
          key: 'vacante_fecha_para_ocupar_la_vacante',
          width: 250,
          // render: (val, record) => (record.fecha_para_ocupar_la_vacante
          //   ? moment(record.fecha_para_ocupar_la_vacante).format('DD/MM/YYYY')
          //   : '—'),

        },

        {
          title: 'Estatus',
          dataIndex: 'vacante_estado_global_descripcion',
          key: 'estatus',
          width: 150,
          render: (val) => val ?? '—',
        },
      ],
    },
    {
      titleText: 'Datos del Solicitante',
      align: 'center',
      children: [
        {
          title: 'Solicitante',
          dataIndex: 'solicitante',
          key: 'solicitante',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Área Solicitante',
          dataIndex: 'solicitante_directorio_de_area_clave_y_nombre',
          key: 'solicitante_area',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Puesto Solicitante',
          dataIndex: 'solicitante_puesto_clave_y_descripcion',
          key: 'solicitante_puesto',
          width: 200,
          render: (val) => val ?? '—',
        },
        {
          title: 'Plaza Solicitante',
          dataIndex: 'solicitante_plaza_clave_y_descripcion',
          key: 'solicitante_plaza',
          width: 250,
          render: (val) => val ?? '—',
        },
        // {
        //   title: 'Tipo de Empleado',
        //   dataIndex: 'tipo_de_empleado_descripcion',
        //   key: 'tipo_empleado',
        //   width: 200,
        //   render: (val) => val ?? '—',
        // },
      ],
    },
  ];

  // FUNCIONES PARA LOS FORMULARIOS

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setIsEditing(false);
    form.resetFields();
    formFiltros.resetFields();
    setActiveTab('solicitante');
    setIsDisabledCompetenciasTab(true);
    setIsDisabledFuncionesTab(true);
    setIsDisabledSolicitanteTab(false);
    setIsDisabledPlazaTab(false);
    setCompetencias([]);
    setFuncionesPrincipales([]);
    setEmpleadoTexto('');
    setPuestoTexto('');
    setAreaTexto('');
    setCategoriaTexto('');
    setPlazaAreaTexto('');
    setPlazaPuestoTexto('');
    setPlazaCategoriaTexto('');
    setSelectedRowKeysComp([]);
    setSelectedFuncionIndex(null);
    setSelectedRowKeysFuncion([]); // <-- limpiar selección exclusiva de funciones
    formCompetencia.resetFields();
    formFuncion.resetFields();
  };

  // Función para abrir el modal de agregar
  // Función para abrir el modal de agregar
  const onClickAdd = async () => {
    onCancel(); // limpia el estado del formulario/modal
    setLoading(true);
    try {
      await checkToken();
      await fetchConceptos(); // <-- carga catálogos
      setVisible(true); // abre el modal ya con catálogos listos
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };
  // Función para abrir el modal de eliminar
  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (!key) {
      onError({ mensaje: 'No se ha seleccionado una solicitud para eliminar' });
      return;
    }
    setSelectedItem(key);
    setVisibleAlert(true);
  };

  // Función para eliminar solicitud
  const deleteItem = async () => {
    if (!selectedItem) return;

    try {
      setDeleting(true);
      await deleteSolicitudDeContratacion(selectedItem);
      onSuccess({ mensaje: 'Solicitud eliminada correctamente' });
      setVisibleAlert(false);
      setSelectedItem(null);
      setSelectedRowKeys([]);
      await fetchData(); // Refresh the data
    } catch (error) {
      onError(error);
    } finally {
      setDeleting(false);
      await fetchData(); // Refresh the data
    }
  };

  const onClickEdit = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) return;
      await fetchConceptos(); // <-- carga catálogos

      const solicitud = await getSolicitudDeContratacion(key);
      if (!solicitud) return;
      // === 1. Setear textos visibles (inputs deshabilitados o de solo lectura)
      const emp = solicitud.empleado;
      setEmpleadoTexto(emp?.numero_y_nombre_completo || '');

      const area = solicitud.directorio_de_area_adscripcion;
      setAreaTexto(area?.clave_y_nombre || '');

      const { puesto } = solicitud;
      let puestoCompletoSolic = null;
      if (puesto?.id) {
        puestoCompletoSolic = await getPuesto(puesto.id);
      }

      setPuestoTexto(
        puestoCompletoSolic
          ? `${puestoCompletoSolic.clave} - ${puestoCompletoSolic.descripcion}`
          : puesto?.descripcion || '',
      );

      const categoria = solicitud.categoria_plaza;
      setCategoriaTexto(categoria?.nombre || '');

      const { plaza } = solicitud;
      if (plaza) {
        setPlazaAreaTexto(plaza.directorio_de_area_clave_y_nombre || '');

        let puestoCompletoPlaza = null;
        if (plaza.puesto_id) {
          puestoCompletoPlaza = await getPuesto(plaza.puesto_id);
        }
        setPlazaPuestoTexto(
          puestoCompletoPlaza
            ? `${puestoCompletoPlaza.clave} - ${puestoCompletoPlaza.descripcion}`
            : plaza.puesto_descripcion || '',
        );

        setPlazaCategoriaTexto(plaza.categoria_nombre || '');
      } else {
        setPlazaAreaTexto('');
        setPlazaPuestoTexto('');
        setPlazaCategoriaTexto('');
      }

      // === 2. Setear campos del formulario (IDs y valores)
      form.setFieldsValue({
        empleado: emp?.id,
        puesto: puesto?.id,
        area_adscripcion: area?.id,
        categoria: categoria?.id,
        plaza_plaza: plaza?.clave_y_descripcion,
        plaza_area: plaza.directorio_de_area_clave_y_nombre,
        plaza_puesto: plaza?.puesto_id,
        plaza_categoria: plaza?.categoria,
        nivel_estudios: solicitud.nivel_de_estudios?.id,
        comprobante_estudios: solicitud.comprobante?.id,
        numero_oficio: solicitud.no_de_oficio || undefined,
        observaciones: solicitud.observaciones || undefined,
        motivo_de_reclutamiento: solicitud.motivo_de_reclutamiento?.id,
        fecha_de_solicitud: solicitud.fecha_de_solicitud
          ? moment(solicitud.fecha_de_solicitud)
          : null,

        prioridad: solicitud.prioridad?.id,
        fecha_para_ocupar_la_vacante: solicitud.fecha_para_ocupar_la_vacante
          ? moment(solicitud.fecha_para_ocupar_la_vacante)
          : null,

        //  Campos de edad (convertidos a número)
        edad_minima: solicitud.edad_minima != null ? Number(solicitud.edad_minima) : null,
        edad_maxima: solicitud.edad_maxima != null ? Number(solicitud.edad_maxima) : null,
      });

      // === 3. Habilitar tabs necesarios
      setIsDisabledCompetenciasTab(false);
      setIsDisabledFuncionesTab(false);
      setIsDisabledSolicitanteTab(false);
      setIsDisabledPlazaTab(false);

      // === 4. Mostrar modal de edición
      setVisible(true);
      setIsEditing(true);
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  const transformarSolicitud = (rawValues) => {
    const values = {
      empleado: rawValues.empleado?.id || rawValues.empleado,
      estado_de_solicitud_de_las_areas: 1, // obligatorio
      plaza: typeof rawValues.plaza_plaza === 'string'
        ? plazas.find((p) => p.clave_y_descripcion === rawValues.plaza_plaza)?.id
        : rawValues.plaza_plaza?.id || rawValues.plaza_plaza,
      estados_globales: 1,
    };

    // Opcionales
    if (rawValues.puesto) {
      values.puesto = rawValues.puesto?.id || rawValues.puesto;
    }
    if (rawValues.area_adscripcion) {
      values.directorio_de_area_adscripcion = rawValues.area_adscripcion?.id || rawValues.area_adscripcion;
    }
    if (rawValues.plaza_area) {
      values.directorio_de_area_adscripcion_plaza = typeof rawValues.plaza_area === 'string'
        ? plazas.find((p) => p.directorio_area_clave_y_nombre === rawValues.plaza_area)?.directorio_area_id
        : rawValues.plaza_area?.id || rawValues.plaza_area;
    }
    if (rawValues.nivel_estudios) {
      values.nivel_de_estudios = rawValues.nivel_estudios?.id || rawValues.nivel_estudios;
    }
    if (rawValues.comprobante_estudios) {
      values.comprobante = rawValues.comprobante_estudios?.id || rawValues.comprobante_estudios;
    }
    if (rawValues.edad_minima) values.edad_minima = rawValues.edad_minima;
    if (rawValues.edad_maxima) values.edad_maxima = rawValues.edad_maxima;
    if (rawValues.numero_oficio) values.no_de_oficio = rawValues.numero_oficio;
    if (rawValues.observaciones) values.observaciones = rawValues.observaciones;
    if (rawValues.motivo_de_reclutamiento) {
      values.motivo_de_reclutamiento = rawValues.motivo_de_reclutamiento?.id || rawValues.motivo_de_reclutamiento;
    }
    if (rawValues.plaza_puesto) {
      values.puesto_plaza = rawValues.plaza_puesto?.id || rawValues.plaza_puesto;
    }
    if (rawValues.plaza_categoria) {
      values.categoria_plaza = rawValues.plaza_categoria?.id || rawValues.plaza_categoria;
    }

    // Nuevo: prioridad
    if (rawValues.prioridad) {
      values.prioridad = rawValues.prioridad?.id || rawValues.prioridad;
    }

    // Nuevo: fecha para ocupar la vacante
    if (rawValues.fecha_para_ocupar_la_vacante) {
      values.fecha_para_ocupar_la_vacante = rawValues.fecha_para_ocupar_la_vacante.format('YYYY-MM-DD');
    }

    // Fecha actual como fecha de solicitud
    values.fecha_de_solicitud = moment().format('YYYY-MM-DD');

    return values;
  };

  // Mapa de campo -> pestaña, usado para llevar al usuario a la pestaña con el
  // campo requerido que falló la validación (antes fallaba con un mensaje
  // genérico "Ha ocurrido un error" sin indicar dónde estaba el problema).
  const REQUIRED_FIELDS_BY_TAB = [
    {
      tabKey: 'plaza',
      tabFields: ['plaza_area', 'plaza_plaza', 'motivo_de_reclutamiento'],
    },
  ];

  // Validación antes de guardar: campos requeridos y tablas llenas
  const validarAntesDeGuardar = async () => {
    try {
      await form.validateFields();
      // if (competencias.length === 0) {
      //   onError({ mensaje: 'Debes agregar al menos una competencia requerida.' });
      //   return false;
      // }
      // if (funcionesPrincipales.length === 0) {
      //   onError({ mensaje: 'Debes agregar al menos una función principal.' });
      //   return false;
      // }
      return true;
    } catch (err) {
      if (err?.errorFields) {
        const errorKeys = err.errorFields.map((e) => e.name[0]);
        const tabWithError = REQUIRED_FIELDS_BY_TAB.find(
          (t) => t.tabFields.some((f) => errorKeys.includes(f)),
        );
        if (tabWithError) {
          setActiveTab(tabWithError.tabKey);
        }
      }
      message.warn('Completa todos los campos obligatorios.');
      return false;
    }
  };

  // Función para cargar las competencias
  const cargarCompetencias = async () => {
    try {
      const [solicitudId] = selectedRowKeys;
      if (!(solicitudId || ultimaSolicitudGuardada)) return;
      const response = await getCompetenciasRequeridas({ solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada });
      setCompetencias(response.results || []);
    } catch (error) {
      onError(error);
    }
  };

  // Función para cargar las funciones principales
  const cargarFuncionesPrincipales = async () => {
    try {
      const [solicitudId] = selectedRowKeys;
      if (!(solicitudId || ultimaSolicitudGuardada)) return;
      const response = await getFuncionesPrincipales({ solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada });
      setFuncionesPrincipales(response.results || []);
    } catch (error) {
      onError(error);
    }
  };

  // Guardar solicitud (agregar o editar)
  const onFinish = async () => {
    const esValido = await validarAntesDeGuardar();
    if (!esValido) return;
    try {
      setLoading(true);
      const rawValues = {
        ...form.getFieldsValue(),
      };
      const values = transformarSolicitud(rawValues);
      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchSolicitudDeContratacion(key, values)
        : postSolicitudDeContratacion(values));
      if (saved) {
        setIsDisabledCompetenciasTab(false);
        setIsDisabledFuncionesTab(false);
        setIsDisabledSolicitanteTab(true);
        setIsDisabledPlazaTab(true);
        setActiveTab('competencias');

        if (key) {
          setUltimaSolicitudGuardada(null);
        } else {
          setUltimaSolicitudGuardada(saved?.id);
          setSelectedRowKeys([saved?.id]);
        }

        // Recargar competencias y funciones para la solicitud guardada
        await cargarCompetencias();
        await cargarFuncionesPrincipales();
      }
      fetchData();
      setLoading(false);
      setIsEditing(false);
      // setVisible(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Efecto para cargar competencias y funciones cuando se selecciona una solicitud
  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      cargarCompetencias();
      cargarFuncionesPrincipales();
      setSelectedRowKeysFuncion([]); // <-- limpiar selección exclusiva de funciones
    } else {
      setCompetencias([]);
      setFuncionesPrincipales([]);
      setSelectedRowKeysFuncion([]); // <-- limpiar selección exclusiva de funciones
    }
  }, [selectedRowKeys]);

  const onClickAgregarCompetencia = () => {
    formCompetencia.resetFields();
    setSelectedCompIndex(null);
    setOpenModalComp(true);
  };

  const onClickEditarCompetencia = () => {
    const selected = competencias.find((c) => c.id === selectedRowKeysComp[0]);
    if (selected) {
      formCompetencia.setFieldsValue(selected);
      setSelectedCompIndex(competencias.findIndex((c) => c.id === selectedRowKeysComp[0]));
      setOpenModalComp(true);
    }
  };

  const handleGuardarCompetencia = async (values) => {
    try {
      const [solicitudId] = selectedRowKeys;
      if (!(solicitudId || ultimaSolicitudGuardada)) {
        onError({ mensaje: 'No se ha seleccionado una solicitud' });
        return;
      }
      const payload = {
        competencia: values.competencia?.trim(),
        porcentaje: parseFloat(values.porcentaje),
        solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada,
        estados_globales: ESTATUS_ACTIVO,
      };

      let result = null;

      if (selectedCompIndex !== null) {
        const { id } = competencias[selectedCompIndex];
        result = await patchCompetenciaRequerida(id, payload);
      } else {
        result = await postCompetenciaRequerida(payload);
      }
      if (result?.id) {
        setOpenModalComp(false);
        formCompetencia.resetFields();
        setSelectedCompIndex(null);
        onSuccess({ mensaje: 'Competencia guardada correctamente' });
      }
      await cargarCompetencias();
      setOpenModalComp(false);
    } catch (error) {
      onError(error);
    }
  };

  const handleCancelarModalComp = () => {
    setOpenModalComp(false);
    formCompetencia.resetFields();
    setSelectedCompIndex(null);
  };

  const onClickEliminarCompetencia = async () => {
    const id = selectedRowKeysComp[0];
    if (!id) return;
    try {
      await deleteCompetenciaRequerida(id);
      await cargarCompetencias();
      setSelectedRowKeysComp([]);
      onSuccess({ mensaje: 'Competencia eliminada correctamente' });
    } catch (err) {
      onError(err);
    }
  };

  const handleOnRowClickComp = (record) => {
    setSelectedRowKeysComp([record.id]);
    formCompetencia.setFieldsValue(record);
  };

  const rowSelectionComp = {
    selectedRowKeys: selectedRowKeysComp,
    onChange: (newSelectedRowKeys) => setSelectedRowKeysComp(newSelectedRowKeys),
    type: 'radio',
  };

  // FUNCIONES PARA FUNCIONES PRINCIPALES ---------------------------------

  const funcionId = Form.useWatch('id', formFuncion);

  const onClickAgregarFuncion = () => {
    // formFuncion.resetFields();
    // setSelectedFuncionIndex(null);
    setOpenModalFuncion(true);
  };

  const onClickEditarFuncion = async () => {
    const selected = funcionesPrincipales.find((f) => f.id === selectedRowKeysFuncion[0]);
    if (selected) {
      formFuncion.setFieldsValue(selected);
      setSelectedFuncionIndex(funcionesPrincipales.findIndex((f) => f.id === selected.id));
      setOpenModalFuncion(true);
    }
  };

  // AQUI REFRESCA LA TABLA DE FUNCIONES PRINCIPALES
  const handleGuardarFuncionPrincipal = async (values) => {
    try {
      const [solicitudId] = selectedRowKeys;
      if (!(solicitudId || ultimaSolicitudGuardada)) {
        onError({ mensaje: 'No se ha seleccionado una solicitud' });
        return;
      }
      const payload = {
        ...values,
        solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada,
        estados_globales: ESTATUS_ACTIVO,
      };
      let result = null;
      if (selectedFuncionIndex !== null) {
        const { id } = funcionesPrincipales[selectedFuncionIndex];
        result = await patchFuncionPrincipal(id, payload);
      } else {
        result = await postFuncionPrincipal(payload);
      }
      if (result) {
        setOpenModalFuncion(false); // Cierra el modal primero
        formFuncion.resetFields(); // Limpia el formulario
        setSelectedFuncionIndex(null);
        await cargarFuncionesPrincipales(); // Refresca la tabla después
        onSuccess({ mensaje: 'Función principal guardada correctamente' });
      }
    } catch (error) {
      onError(error);
    }
  };

  const handleCancelarModalFuncion = () => {
    formFuncion.resetFields();
    setOpenModalFuncion(false);
    setSelectedFuncionIndex(null);
    setSelectedRowKeysFuncion([]);
  };

  const onClickEliminarFuncion = async () => {
    const id = selectedRowKeysFuncion[0];
    if (!id) return;
    try {
      await deleteFuncionPrincipal(id);
      await cargarFuncionesPrincipales(); // Refresca la tabla
      setSelectedRowKeysFuncion([]);
      onSuccess({ mensaje: 'Función principal eliminada correctamente' });
    } catch (err) {
      onError(err);
    }
  };

  const rowSelectionFuncion = {
    selectedRowKeys: selectedRowKeysFuncion,
    onChange: (newSelectedRowKeys) => setSelectedRowKeysFuncion(newSelectedRowKeys),
    type: 'radio',
  };
  // Cuando seleccionas un área
  const handleAreaChange = (areaId) => {
  // Filtrar solo plazas disponibles de esa área
    const disponibles = plazas.filter(
      (p) => p.directorio_area_id === areaId && ESTADOS_PLAZA_VACANTE.includes(p.estado_plaza),
    );

    setPlazasFiltradas(disponibles);

    // Reset de la plaza seleccionada
    form.setFieldsValue({ plaza_plaza: null });
    setPlazaPuestoTexto('');
    setPlazaCategoriaTexto('');
  };

  // Cuando seleccionas una plaza
  const handlePlazaChange = async (plazaId) => {
    const plazaSeleccionada = plazas.find((p) => p.id === plazaId);

    if (plazaSeleccionada) {
      form.setFieldsValue({
        plaza_plaza: plazaSeleccionada.id,
        plaza_puesto: plazaSeleccionada.puesto_id,
        plaza_categoria: plazaSeleccionada.categoria_de_puesto_id,
        tipo_empleado: plazaSeleccionada.tipo_de_empleado_id,
      });

      // Fetch puntual
      let puestoCompleto = null;
      if (plazaSeleccionada.puesto_id) {
        puestoCompleto = await getPuesto(plazaSeleccionada.puesto_id);
      }

      setPlazaPuestoTexto(
        puestoCompleto
          ? `${puestoCompleto.clave} - ${puestoCompleto.descripcion}`
          : plazaSeleccionada.puesto || '',
      );

      setPlazaCategoriaTexto(plazaSeleccionada.categoria_de_empleado || '');
    } else {
      form.resetFields(['plaza_plaza', 'plaza_puesto', 'plaza_categoria', 'tipo_empleado']);
      setPlazaPuestoTexto('');
      setPlazaCategoriaTexto('');
    }
  };

  const ordenarPorClave = (a, b, campo) => {
    const claveA = a[campo]?.split(' - ')[0] || '';
    const claveB = b[campo]?.split(' - ')[0] || '';

    const arrA = claveA.split('.').map((n) => parseInt(n, 10) || 0);
    const arrB = claveB.split('.').map((n) => parseInt(n, 10) || 0);

    const len = Math.max(arrA.length, arrB.length);

    for (let i = 0; i < len; i += 1) {
      const valA = arrA[i] ?? 0;
      const valB = arrB[i] ?? 0;
      if (valA !== valB) return valA - valB;
    }

    return 0;
  };

  // Define handleOnRowClickFuncion for the Table in Funciones Principales tab
  const handleOnRowClickFuncion = (record) => {
    setSelectedRowKeysFuncion([record.id]);
    formFuncion.setFieldsValue(record);
  };

  // Función para construir la URL de búsqueda con solo los filtros llenados
  const buildBusquedaURI = (filtros) => {
    let uri = '';
    if (filtros.area_adscripcion) {
      uri += `area_adscripcion=${filtros.area_adscripcion};`;
    }
    if (filtros.estados_globales) {
      uri += `estados_globales=${filtros.estados_globales};`;
    }
    if (filtros.puesto) {
      uri += `puesto=${filtros.puesto};`;
    }
    if (filtros.categoria) {
      uri += `categoria=${filtros.categoria};`;
    }
    return uri;
  };

  const onConfirmAutorizar = async () => {
    setLoading(true);
    try {
      const [key] = selectedRowKeys;

      if (!key) {
        onSuccess({}, 'No se puede autorizar la solicitud ya autorizada');
        setConfirmationVisible(false); // ← cerrar solo el modal de confirmación
        return;
      }

      const saved = await autorizarSolicitudDeContratacion(key);

      if (saved) {
        await fetchData();
        setSelectedRowKeys([]);
        onSuccess({}, 'Solicitud autorizada correctamente');
      }

      setConfirmationVisible(false); // ← cerrar solo el modal de confirmación
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };
  const handleBuscarClick = () => {
    const filtros = formFiltros.getFieldsValue();
    onBuscar(filtros);
  };
  // Utilidad para generar opciones únicas
  const generarOpcionesUnicas = (datos, campoId, campoDescripcion) => Array.from(
    new Map(
      datos
        .filter((e) => e[campoId] && e[campoDescripcion])
        .map((e) => [
          e[campoId],
          {
            id: e[campoId],
            descripcion: e[campoDescripcion]?.trim?.() || e[campoDescripcion],
          },
        ]),
    ).values(),
  );

  // Garantizamos que solicitudes sea un arreglo para evitar errores
  const solicitudesList = Array.isArray(solicitudes) ? solicitudes : [];

  // === OPCIONES DEL SOLICITANTE CORREGIDAS ===

  // PLAZA (del solicitante)
  const opcionesPlaza = generarOpcionesUnicas(
    solicitudesList,
    'solicitante_plaza_id',
    'solicitante_plaza_clave_y_descripcion',
  );

  // ÁREA (del solicitante)
  const opcionesArea = generarOpcionesUnicas(
    solicitudesList,
    'solicitante_directorio_de_area_id',
    'solicitante_directorio_de_area_clave_y_nombre',
  );

  // PUESTO (del solicitante)
  const opcionesPuesto = generarOpcionesUnicas(
    solicitudesList,
    'solicitante_puesto_id',
    'solicitante_puesto_clave_y_descripcion',
  );

  // TIPO DE EMPLEADO (si aplica)
  const opcionesTipoEmpleado = generarOpcionesUnicas(
    solicitudesList,
    'tipo_de_empleado_id', // ← Solo si existe ese campo en la API
    'tipo_de_empleado_descripcion',
  );

  // ESTATUS (de la vacante)
  const opcionesEstatus = generarOpcionesUnicas(
    solicitudesList,
    'vacante_estado_global_id',
    'vacante_estado_global_descripcion',
  );

  // 1. Obtener áreas únicas desde las plazas
  const opcionesAreas = [...new Map(
    plazas.map((p) => [p.directorio_area_id, {
      id: p.directorio_area_id,
      descripcion: p.directorio_area_clave_y_nombre,
      clave: p.directorio_area_clave_y_nombre?.split(' - ')[0] || '', // clave numérica
    }]),
  ).values()];

  // 2. Ordenarlas por clave numérica
  opcionesAreas.sort((a, b) => {
    const claveA = a.clave.split('.').map((x) => parseInt(x, 10));
    const claveB = b.clave.split('.').map((x) => parseInt(x, 10));
    const len = Math.max(claveA.length, claveB.length);

    for (let i = 0; i < len; i += 1) {
      const valA = claveA[i] ?? 0;
      const valB = claveB[i] ?? 0;
      if (valA !== valB) return valA - valB;
    }
    return 0;
  });

  const onClickExportarExcel = async () => {
    try {
      setLoading(true);
      message.info('Exportando vacantes con todos los campos del backend...');

      // Llamamos a la API para traer todos los registros
      const response = await getSolicitudDeContratacionvistaOptimized();
      const rawData = response?.results || response || [];

      if (rawData.length === 0) {
        message.error('No se encontraron registros para exportar.');
        setLoading(false);
        return;
      }

      // Procesar y formatear datos
      const excelData = rawData.map((record) => {
        const row = { ...record };

        if (row.vacante_fecha_de_solicitud) {
          row.vacante_fecha_de_solicitud = moment(row.vacante_fecha_de_solicitud).format('DD/MM/YYYY');
        }
        if (row.vacante_fecha_para_ocupar_la_vacante) {
          row.vacante_fecha_para_ocupar_la_vacante = moment(row.vacante_fecha_para_ocupar_la_vacante).format('DD/MM/YYYY');
        }

        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];

      // Ajuste de ancho automático de columnas
      const colWidths = Object.keys(excelData[0] || {}).map((key) => ({
        wch: Math.max(key.length, ...excelData.map((row) => String(row[key] || '').length)) + 2,
      }));
      worksheet['!cols'] = colWidths;

      // Estilo de la cabecera
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; C += 1) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) worksheet[cellAddress] = { v: '' };
        worksheet[cellAddress].s = {
          font: { bold: true, sz: 11 },
          fill: { patternType: 'solid', fgColor: { rgb: 'D9D9D9' } },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        };
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Vacantes');

      const fecha = moment().format('YYYY-MM-DD');
      const fileName = `Listado_Vacantes_${fecha}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      setLoading(false);
      message.success(`Exportadas ${excelData.length} vacantes correctamente`);
    } catch (err) {
      message.error('Error al generar el documento Excel.');
      setLoading(false);
    }
  };

  const onClickDescargarPlantilla = async () => {
    try {
      setLoading(true);

      // Fetch directo para garantizar datos frescos (no depende del state/ref de caché)
      const [_rawPlazas, _rawAreas, _rawMotivos] = await Promise.all([
        getPlazasvistaOptimized(),
        getDirectorioDeAreas(),
        getMotivosDeReclutamiento(),
      ]);
      const _plazas = Array.isArray(_rawPlazas) ? _rawPlazas : (_rawPlazas?.results || []);
      const _areas = Array.isArray(_rawAreas) ? _rawAreas : (_rawAreas?.results || []);
      const _motivos = Array.isArray(_rawMotivos) ? _rawMotivos : (_rawMotivos?.results || []);

      // ── Colores institucionales (ARGB para ExcelJS) ───────────────────────
      const AZUL_OSCURO = 'FF003366';
      const AZUL_TITULO = 'FF1F3864';
      const BLANCO = 'FFFFFFFF';
      const GRIS = 'FFD9D9D9';

      const workbook = new ExcelJS.Workbook();
      const hoy = moment();

      // ── Hoja principal "Vacantes" (primera hoja) ──────────────────────────
      const ws = workbook.addWorksheet('Vacantes');
      ws.getColumn('A').width = 55;
      ws.getColumn('B').width = 55;
      ws.getColumn('C').width = 45;
      ws.getColumn('D').width = 30;

      // Fila 1: nombre entidad
      ws.getRow(1).height = 40;
      ws.mergeCells('A1:D1');
      const celdaEntidad = ws.getCell('A1');
      celdaEntidad.value = nombreEntidad.toUpperCase();
      celdaEntidad.font = {
        name: 'Calibri', size: 20, bold: true, color: { argb: AZUL_TITULO },
      };
      celdaEntidad.alignment = { horizontal: 'left', vertical: 'middle' };

      // Fila 2: línea decorativa azul
      ws.getRow(2).height = 6;
      ws.mergeCells('A2:D2');
      ws.getCell('A2').fill = {
        type: 'pattern', pattern: 'solid', fgColor: { argb: AZUL_OSCURO },
      };

      // Fila 3: vacía
      ws.getRow(3).height = 8;

      // Fila 4: PLANTILLA DE CARGA PARA
      ws.getRow(4).height = 20;
      ws.mergeCells('A4:B4');
      const etiq4 = ws.getCell('A4');
      etiq4.value = 'PLANTILLA DE CARGA PARA:';
      etiq4.font = { name: 'Calibri', size: 11, bold: true };
      etiq4.alignment = { horizontal: 'left', vertical: 'middle' };
      ws.mergeCells('C4:D4');
      const val4 = ws.getCell('C4');
      val4.value = 'Vacante / Solicitud de Contratación';
      val4.font = { name: 'Calibri', size: 11 };
      val4.alignment = { horizontal: 'left', vertical: 'middle' };

      // Fila 5: FECHA
      ws.getRow(5).height = 20;
      ws.mergeCells('A5:B5');
      const etiq5 = ws.getCell('A5');
      etiq5.value = 'FECHA';
      etiq5.font = { name: 'Calibri', size: 11, bold: true };
      etiq5.alignment = { horizontal: 'left', vertical: 'middle' };
      ws.mergeCells('C5:D5');
      const val5 = ws.getCell('C5');
      val5.value = `${hoy.month() + 1}/${hoy.date()}/${hoy.year()}`;
      val5.font = { name: 'Calibri', size: 11 };
      val5.alignment = { horizontal: 'left', vertical: 'middle' };

      // Fila 6: vacía
      ws.getRow(6).height = 8;

      // Fila 7: encabezados con fondo azul oscuro y texto blanco
      ws.getRow(7).height = 22;
      [
        ['A7', '*Plaza (Clave)'],
        ['B7', 'Area (Clave)'],
        ['C7', 'Motivos de Reclutamiento'],
        ['D7', 'Solicitante (Núm. Empleado)'],
      ].forEach(([addr, titulo]) => {
        const cell = ws.getCell(addr);
        cell.value = titulo;
        cell.font = {
          name: 'Calibri', size: 11, bold: true, color: { argb: BLANCO },
        };
        cell.fill = {
          type: 'pattern', pattern: 'solid', fgColor: { argb: AZUL_OSCURO },
        };
        cell.alignment = {
          horizontal: 'center', vertical: 'middle', wrapText: true,
        };
        cell.border = {
          left: { style: 'thin', color: { argb: GRIS } },
          right: { style: 'thin', color: { argb: GRIS } },
          top: { style: 'thin', color: { argb: GRIS } },
          bottom: { style: 'thin', color: { argb: GRIS } },
        };
      });

      // ── Hoja oculta "Catalogos" para las validaciones desplegables ────────
      // ── Hoja oculta "Catalogos" con los valores que usan los dropdowns ──────
      // Plaza col A: "clave - descripcion"  → el backend extrae la parte antes del " - "
      // Área  col B: "clave - nombre"        → igual
      // Motivos col C: nombre completo
      const catSheetData = workbook.addWorksheet('Catalogos', { state: 'hidden' });
      _plazas.forEach((p, i) => {
        catSheetData.getCell(i + 1, 1).value = p.clave_y_descripcion || p.clave || '';
      });
      _areas.forEach((a, i) => {
        catSheetData.getCell(i + 1, 2).value = a.clave && a.nombre ? `${a.clave} - ${a.nombre}` : (a.clave || '');
      });
      _motivos.forEach((m, i) => { catSheetData.getCell(i + 1, 3).value = m.nombre || ''; });

      // ── Validaciones desplegables ─────────────────────────────────────────
      if (_plazas.length > 0) {
        ws.dataValidations.add('A8:A10000', {
          type: 'list',
          allowBlank: true,
          formulae: [`Catalogos!$A$1:$A$${_plazas.length}`],
          showErrorMessage: true,
          errorTitle: 'Valor inválido',
          error: 'Seleccione una plaza de la lista desplegable.',
          showInputMessage: true,
          promptTitle: 'Plaza',
          prompt: 'Haga clic en la flecha para elegir.',
        });
      }
      if (_areas.length > 0) {
        ws.dataValidations.add('B8:B10000', {
          type: 'list',
          allowBlank: true,
          formulae: [`Catalogos!$B$1:$B$${_areas.length}`],
          showErrorMessage: true,
          errorTitle: 'Valor inválido',
          error: 'Seleccione un área de la lista desplegable.',
          showInputMessage: true,
          promptTitle: 'Área',
          prompt: 'Haga clic en la flecha para elegir.',
        });
      }
      if (_motivos.length > 0) {
        ws.dataValidations.add('C8:C10000', {
          type: 'list',
          allowBlank: true,
          formulae: [`Catalogos!$C$1:$C$${_motivos.length}`],
          showErrorMessage: true,
          errorTitle: 'Valor inválido',
          error: 'Seleccione un motivo de la lista desplegable.',
          showInputMessage: true,
          promptTitle: 'Motivo de Reclutamiento',
          prompt: 'Haga clic en la flecha para elegir.',
        });
      }

      // ── Hoja visible: Catálogo Áreas ─────────────────────────────────────
      if (_areas.length > 0) {
        const wsAreas = workbook.addWorksheet('Catálogo Áreas');
        wsAreas.getColumn('A').width = 20;
        wsAreas.getColumn('B').width = 70;
        ['A1', 'B1'].forEach((addr, idx) => {
          const cell = wsAreas.getCell(addr);
          cell.value = ['Clave', 'Nombre'][idx];
          cell.font = { bold: true, color: { argb: BLANCO } };
          cell.fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: AZUL_OSCURO },
          };
          cell.alignment = { horizontal: 'center' };
        });
        _areas.forEach((a, i) => {
          wsAreas.getCell(i + 2, 1).value = a.clave || '';
          wsAreas.getCell(i + 2, 2).value = a.nombre || '';
        });
      }

      // ── Hoja visible: Catálogo Plazas ─────────────────────────────────────
      if (_plazas.length > 0) {
        const wsPlazas = workbook.addWorksheet('Catálogo Plazas');
        wsPlazas.getColumn('A').width = 20;
        wsPlazas.getColumn('B').width = 70;
        ['A1', 'B1'].forEach((addr, idx) => {
          const cell = wsPlazas.getCell(addr);
          cell.value = ['Clave', 'Descripción'][idx];
          cell.font = { bold: true, color: { argb: BLANCO } };
          cell.fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: AZUL_OSCURO },
          };
          cell.alignment = { horizontal: 'center' };
        });
        _plazas.forEach((p, i) => {
          wsPlazas.getCell(i + 2, 1).value = p.clave || '';
          wsPlazas.getCell(i + 2, 2).value = p.clave_y_descripcion || '';
        });
      }

      // ── Hoja visible: Catálogo Motivos ────────────────────────────────────
      if (_motivos.length > 0) {
        const wsMotivos = workbook.addWorksheet('Catálogo Motivos');
        wsMotivos.getColumn('A').width = 60;
        const hdrCell = wsMotivos.getCell('A1');
        hdrCell.value = 'Nombre del Motivo';
        hdrCell.font = { bold: true, color: { argb: BLANCO } };
        hdrCell.fill = {
          type: 'pattern', pattern: 'solid', fgColor: { argb: AZUL_OSCURO },
        };
        hdrCell.alignment = { horizontal: 'center' };
        _motivos.forEach((m, i) => {
          wsMotivos.getCell(i + 2, 1).value = m.nombre || '';
        });
      }

      // ── Generar buffer y descargar ────────────────────────────────────────
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Layout_Vacantes.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      message.success('Plantilla descargada correctamente');
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);

        // Construcción de la URL
        const uri = baseURIImportar.endsWith('/') ? baseURIImportar : `${baseURIImportar}/`;

        const response = await API.post(`${baseURL}${uri}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response?.status === 200 || response?.status === 201) {
          const { importados, errores } = response.data;

          if (errores && errores.length > 0) {
            errores.forEach((err) => message.error(err, 6));
          }

          if (importados > 0) {
            message.success(`Se importaron ${importados} vacante(s) correctamente.`);
          } else if (!errores || errores.length === 0) {
            message.warning('No se encontraron filas con datos para importar.');
          }

          setVisibleModalCarga(false);
          formCarga.resetFields();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: '1',
          label: 'Descargar Plantilla',
          icon: <DownloadOutlined />,
          onClick: onClickDescargarPlantilla,
        },
        {
          key: '2',
          label: 'Cargar Excel',
          icon: <DownloadOutlined />,
          onClick: () => setVisibleModalCarga(true),
        },
      ]}
    />
  );

  useEffect(() => {
    let filtradosTab = [];
    if (activeGridTab === TAB_DISPONIBLES) {
      filtradosTab = filteredSolicitudes.filter((v) => (v.vacante_estado_global_id === 1 || v.vacante_estado_global_id === 4)
        && v.vacante_estado_de_solicitud_de_las_areas_id !== 8);
    } else if (activeGridTab === TAB_CONTRATADAS) {
      filtradosTab = filteredSolicitudes.filter((v) => v.vacante_estado_de_solicitud_de_las_areas_id === 8);
    }
    setTabFilteredSolicitudes(filtradosTab);
  }, [filteredSolicitudes, activeGridTab]);

  useEffect(() => {
    setSelectedRowKeys([]); // Limpiar selección solo al cambiar de tab
  }, [activeGridTab]);

  const renderMainTable = () => (
    <Table
      cols={columns}
      data={tabFilteredSolicitudes} // Se usan los datos pasados por el tab
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      permission={permission}
      allowExportPDF={false}
      pagination
      controls={{
        onClickAdd,
        onClickEdit,
        onClickDelete,
      }}
      allowCustomImport
      customImportMenu={menuImport}
      customImportText="Importar Excel"
      customActions={[
        {
          onClick: () => setConfirmationVisible(true),
          permission: { model: 'solicituddecontratacion', action: 'autorizar' },
          text: 'Autorizar',
          icon: <CheckCircleOutlined />,
          disabledBySelection: false,
          className: 'success',
          disabled:
            !selectedRowKeys?.length
            || solicitudes?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO,
        },
      ]}
    />
  );
  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Col>

          {/* <Form
            form={formFiltros}
            layout="vertical"
            name="form-filtros"
            onFinish={onBuscar}
          >
            <Row gutter={[16, 16]}>
              <Col xs={24}>
                <Text style={{ color: '#D88F4F' }}>SOLICITUD DE CONTRATACIÓN POR ÁREA</Text>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="fecha_de_solicitud" label="Fecha de Solicitud">
                  <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="folio" label="Folio">
                  <Input />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="nombreCompleto" label="Solicitante">
                  <Input allowClear />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="directorio_area" label="Área">
                  <Select
                    dataSource={opcionesArea}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="plaza" label="Plaza">
                  <Select
                    dataSource={opcionesPlaza}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="puesto" label="Puesto">
                  <Select
                    dataSource={opcionesPuesto}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="tipo_nomina_empleado" label="Tipo de Empleado">
                  <Select
                    dataSource={opcionesTipoEmpleado}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="estatus" label="Estatus">
                  <Select
                    dataSource={opcionesEstatus}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Button
                  icon={<SearchOutlined />}
                  onClick={async () => {
                    try {
                      const filtros = await formFiltros.validateFields();
                      onBuscar(filtros);
                    } catch (error) {
                      // No hacer nada si hay campos requeridos no llenados
                    }
                  }}
                >
                  Buscar
                </Button>

                <Button
                  onClick={() => {
                    formFiltros.resetFields();
                    onBuscar({}); // <- Importante para restablecer los datos
                  }}
                >
                  Limpiar filtros
                </Button>
              </Col>

            </Row>
          </Form> */}

        </Col>
        <Col xs={24}>
          <Card bordered={false} className="tables-container" style={{ marginTop: 20 }}>
            <Tabs
              defaultActiveKey={TAB_DISPONIBLES}
              activeKey={activeGridTab}
              onChange={setActiveGridTab}
              items={[
                {
                  key: TAB_DISPONIBLES,
                  label: 'Vacantes Disponibles',
                  children: renderMainTable(),
                },
                {
                  key: TAB_CONTRATADAS,
                  label: 'Vacantes Contratadas',
                  children: renderMainTable(),
                },
              ]}
            />
          </Card>

          {/* Modal Agregar/Editar */}
          <Modal
            open={open}
            width="55%"
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Vacante`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              form={form}
              layout="vertical"
              name="vacantes"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                is_active: true,
                vigencia_inicial: moment(),
              }}
              onFinish={onFinish}
            >
              <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                destroyInactiveTabPane={false}
                items={[
                  {
                    key: 'solicitante',
                    label: 'Solicitante',
                    disabled: IsDisabledSolicitanteTab,
                    forceRender: true,
                    children: (
                      <Row gutter={16}>
                        <Form.Item name="empleado" hidden><Input /></Form.Item>
                        <Form.Item name="puesto" hidden><Input /></Form.Item>
                        <Form.Item name="area_adscripcion" hidden><Input /></Form.Item>
                        <Form.Item name="categoria" hidden><Input /></Form.Item>
                        <Form.Item name="plaza" hidden><Input /></Form.Item>

                        <Col xs={24} sm={12}>
                          <Form.Item label="Fecha de Solicitud">
                            <Input disabled value={moment().format('DD-MM-YYYY')} />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={12}>
                          <Form.Item label="Solicitante">
                            <Input.Group compact>
                              <Input
                                readOnly
                                value={empleadoTexto}
                                style={{ width: 'calc(100% - 40px)' }}
                              />
                              <Button
                                icon={<SearchOutlined />}
                                onClick={() => setOpenModalEmpleados(true)}
                              />
                            </Input.Group>
                          </Form.Item>
                        </Col>

                        <CustomSearch
                          form={formEmpleados}
                          open={openModalEmpleado}
                          setVisible={setOpenModalEmpleados}
                          modalTitle="Buscar Empleado"
                          firstInputLabel="No. de Empleado"
                          firstInputName="numero_de_empleado"
                          secondInputLabel="Nombre del Empleado"
                          secondInputName="nombre"
                          searchInputLabel="Apellido Paterno"
                          searchInputName="apellido_paterno"
                          thirdInputLabel="Apellido Materno"
                          thirdInputName="apellido_materno"
                          firstSelectLabel="Tipo de Nómina Empleado"
                          firstSelectName="tipo_de_nomina_empleado"
                          firstSelectDataSource={tiposDeNominaEmpleado}
                          inputsNeeded={3}
                          selectsNeeded={1}
                          paginatedTable
                          modalWidth={1400}
                          columns={columnsBusquedaEmpleados}
                          baseURI={baseURIPagination}
                          setSelectedRow={setSelectedEmpleadoSearch}
                          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
                          formatReceivedClone={formatReceivedClone}
                          data={data}
                          setData={setData}
                          searchData={searchData}
                          onChange={onChangeEmpleado}
                        />

                        <Col xs={24} sm={12}>
                          <Form.Item label="Área">
                            <Input value={areaTexto} disabled />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={12}>
                          <Form.Item label="Puesto">
                            <Input value={puestoTexto} disabled />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={12}>
                          <Form.Item label="Plaza">
                            <Input value={plazaTexto} disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: 'plaza',
                    label: 'Plaza',
                    disabled: IsDisabledPlazaTab,
                    forceRender: true,
                    children: (
                      <>
                        <Form.Item name="plaza_area" hidden><Input /></Form.Item>
                        <Form.Item name="plaza_puesto" hidden><Input /></Form.Item>
                        <Form.Item name="plaza_categoria" hidden><Input /></Form.Item>

                        <Row gutter={16}>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="plaza_area"
                              label="Área"
                              rules={[{ required: true, message: 'El área es obligatoria' }]}
                            >
                              <Select
                                dataSource={Array.from(
                                  new Map(
                                    plazas
                                      .filter((p) => ESTADOS_PLAZA_VACANTE.includes(p.estado_plaza))
                                      .map((p) => [
                                        p.directorio_area_id,
                                        {
                                          id: p.directorio_area_id,
                                          descripcion: p.directorio_area_clave_y_nombre,
                                        },
                                      ]),
                                  ).values(),
                                ).sort((a, b) => ordenarPorClave(a, b, 'descripcion'))}
                                keyProp="id"
                                labelProp="descripcion"
                                render={(a) => a.descripcion}
                                showSearch
                                onChange={handleAreaChange}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="plaza_plaza"
                              label="Plaza"
                              rules={rules.required}
                            >
                              <Select
                                dataSource={[...plazasFiltradas].sort((a, b) => ordenarPorClave(a, b, 'clave_y_descripcion'))}
                                keyProp="id"
                                labelProp="clave_y_descripcion"
                                render={(p) => p?.clave_y_descripcion}
                                showSearch
                                onChange={handlePlazaChange}
                                disabled={!form.getFieldValue('plaza_area')}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item label="Puesto">
                              <Input value={plazaPuestoTexto} disabled />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item label="Tipo de Empleado">
                              <Input value={plazaCategoriaTexto} disabled />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="nivel_estudios" label="Escolaridad Mínima">
                              <Select
                                labelProp="nombre"
                                keyProp="id"
                                dataSource={nivelEstudio}
                                render={(item) => `${item?.nombre}`}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="comprobante_estudios" label="Comprobante de Estudios">
                              <Select
                                labelProp="nombre"
                                keyProp="comprobantesDeEstudio"
                                dataSource={comprobantesDeEstudio}
                                render={(item) => `${item?.nombre}`}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="edad_minima" label="Edad Mínima">
                              <InputNumber min={0} style={{ width: '100%' }} />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="edad_maxima" label="Edad Máxima">
                              <InputNumber min={0} style={{ width: '100%' }} />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="numero_oficio" label="No. de Oficio de Solicitud">
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="motivo_de_reclutamiento"
                              label="Motivo de Solicitud"
                              rules={[{ required: true, message: 'Selecciona un motivo de reclutamiento' }]}
                            >
                              <Select
                                labelProp="nombre"
                                keyProp="id"
                                render={(item) => item.nombre}
                                dataSource={motivosDeReclutamiento}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="prioridad" label="Prioridad">
                              <Select
                                dataSource={prioridades}
                                keyProp="id"
                                labelProp="descripcion"
                                render={(item) => item.descripcion}
                                showSearch
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Form.Item name="fecha_para_ocupar_la_vacante" label="Fecha para Ocupar la Vacante">
                              <DatePicker
                                style={{ width: '100%' }}
                                format="YYYY-MM-DD"
                                placeholder={null}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                  {
                    key: 'competencias',
                    label: 'Competencias Requeridas',
                    disabled: IsDisabledCompetenciasTab,
                    children: (
                      <>
                        <Row gutter={16}>
                          <Col xs={24}>
                            <Table
                              cols={[
                                {
                                  titleText: 'No.',
                                  dataIndex: 'numero',
                                  key: 'numero',
                                  width: 70,
                                },
                                {
                                  titleText: 'Competencias',
                                  dataIndex: 'competencia',
                                  key: 'competencia',
                                  width: 120,
                                },
                                {
                                  titleText: 'Porcentaje',
                                  dataIndex: 'porcentaje',
                                  key: 'porcentaje',
                                  width: 90,
                                  render: (val) => `${val}%`,
                                },
                              ]}
                              data={competencias}
                              rowSelection={rowSelectionComp}
                              handleOnRowClick={handleOnRowClickComp}
                              permission={permission}
                              allowExportPDF={false}
                              controls={{
                                onClickAdd: onClickAgregarCompetencia,
                                onClickEdit: onClickEditarCompetencia,
                                onClickDelete: onClickEliminarCompetencia,
                              }}
                            />
                          </Col>
                        </Row>

                        <Modal
                          open={openModalComp}
                          footer={null}
                          title={(
                            <FormSubmitControls
                              label={`${selectedCompIndex !== null ? 'Editar' : 'Agregar'} Agregar Competencia`}
                              onFinish={() => formCompetencia.submit()}
                              onCancel={handleCancelarModalComp}
                              loading={loading}
                            />
                          )}
                          onCancel={handleCancelarModalComp}
                          width="40%"
                        >
                          <Form
                            form={formCompetencia}
                            layout="vertical"
                            onFinish={handleGuardarCompetencia}
                          >
                            <Row gutter={16}>
                              <Col xs={24}>
                                <Form.Item
                                  name="competencia"
                                  label="Competencia"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'La competencia es obligatoria',
                                      transform: (value) => (typeof value === 'string' ? value.trim() : value),
                                    },
                                    { max: 500, message: 'Máximo 500 caracteres' },
                                  ]}
                                  validateTrigger={['onChange', 'onBlur']}
                                >
                                  <Input.TextArea rows={3} />
                                </Form.Item>
                              </Col>

                              <Col xs={24}>
                                <Form.Item
                                  name="porcentaje"
                                  label="Porcentaje"
                                  valuePropName="value"
                                  getValueFromEvent={(e) => {
                                    if (typeof e === 'string') return parseFloat(e);
                                    return e;
                                  }}
                                  rules={[
                                    { required: true, message: 'El porcentaje es obligatorio' },
                                    {
                                      type: 'number',
                                      min: 0,
                                      max: 100,
                                      message: 'El porcentaje debe estar entre 0 y 100',
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    min={0}
                                    max={100}
                                    step={0.01}
                                    style={{ width: '100%' }}
                                    stringMode
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </Modal>
                      </>
                    ),
                  },
                  {
                    key: 'funciones',
                    label: 'Funciones Principales',
                    disabled: IsDisabledFuncionesTab,
                    children: (
                      <>
                        <Row gutter={16}>
                          <Col xs={24}>
                            <Form.Item name="observaciones" label="Observaciones">
                              <Input.TextArea rows={2} />
                            </Form.Item>
                          </Col>

                          <Col xs={24}>
                            <Table
                              cols={[
                                {
                                  titleText: 'No.',
                                  dataIndex: 'id',
                                  key: 'id',
                                  width: 80,
                                },
                                {
                                  titleText: 'Funciones Principales',
                                  dataIndex: 'funcion',
                                  key: 'funcion',
                                },
                              ]}
                              data={funcionesPrincipales}
                              rowSelection={rowSelectionFuncion}
                              handleOnRowClick={handleOnRowClickFuncion}
                              permission={permission}
                              allowExportPDF={false}
                              controls={{
                                onClickAdd: onClickAgregarFuncion,
                                onClickEdit: onClickEditarFuncion,
                                onClickDelete: onClickEliminarFuncion,
                              }}
                            />
                          </Col>
                        </Row>

                        <Modal
                          open={openModalFuncion}
                          footer={null}
                          title={(
                            <FormSubmitControls
                              label={`${selectedFuncionIndex !== null ? 'Editar' : 'Agregar'} Agregar Función Principal`}
                              onFinish={() => formFuncion.submit()}
                              onCancel={handleCancelarModalFuncion}
                              loading={loading}
                            />
                          )}
                          onCancel={handleCancelarModalFuncion}
                          width="40%"
                        >
                          <Form
                            form={formFuncion}
                            layout="vertical"
                            onFinish={handleGuardarFuncionPrincipal}
                          >
                            <Row gutter={16}>
                              {funcionId && (
                                <Col xs={24}>
                                  <Form.Item label="No.">
                                    <Input value={funcionId} disabled />
                                  </Form.Item>
                                </Col>
                              )}

                              <Col xs={24}>
                                <Form.Item
                                  name="funcion"
                                  label="Función"
                                  rules={[
                                    { required: true, message: 'Campo obligatorio' },
                                    {
                                      validator: (_, value) => (value && value.trim() !== ''
                                        ? Promise.resolve()
                                        : Promise.reject(new Error('Campo obligatorio'))),
                                    },
                                  ]}
                                >
                                  <Input.TextArea rows={2} />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </Modal>
                      </>
                    ),
                  },
                ]}
              />
              {/* Botón oculto para submit por Enter */}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>

          {/* Modal Delete */}
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => {
              setVisibleAlert(false);
              setSelectedItem(null);
            }}
            open={visibleAlert}
            content={`la Solicitud con folio ${selectedItem ? solicitudes?.find((s) => s.id === selectedItem)?.folio || 'N/A' : 'N/A'}`}
            loading={deleting}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => {
              setConfirmationVisible(false);
            }}
            open={confirmationVisible}
            contentTitle={`Autorizar la Solicitud con Folio ${form.getFieldValue('vacante__folio') || '—'}?`}
            loading={loading}
          />

          <Modal
            open={visibleModalCarga}
            title={(
              <FormSubmitControls
                label="Carga Masiva de Vacantes"
                onFinish={onUpload}
                onCancel={() => {
                  setVisibleModalCarga(false);
                  formCarga.resetFields();
                }}
                loading={loading}
              />
           )}
            onCancel={() => {
              setVisibleModalCarga(false);
              formCarga.resetFields();
            }}
            footer={null}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            destroyOnClose
          >
            <Spin tip="Procesando archivo..." spinning={loading}>
              <Form
                layout="vertical"
                form={formCarga}
                name="cargaVacantes"
              >
                <Dragger
                  label="Seleccione el archivo Excel (.xlsx)"
                  limitMB={20}
                  rules={[{ required: true, message: 'El archivo es obligatorio' }]}
                  name="file"
                  allowedExtensions={['xlsx']}
                />
              </Form>
            </Spin>
          </Modal>
        </Col>

      </Spin>
    </Row>
  );
};

export default ListadoDeVacantes;
